import {
  MDSModalDialog,
  MDSDialogSlotName,
  MDSButton,
  MDSText,
  MDSTextVariant,
  MDSButtonVariant,
} from "@/mds";
import WelcomeToProImage from "@/assets/images/welcome-to-pro.svg";
import styled from "@emotion/styled";

interface WelcomeToProModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const WelcomeToProModal = ({ isOpen, onClose }: WelcomeToProModalProps) => {
  return (
    <MDSModalDialog isOpen={isOpen} handleClose={onClose} fluidWidth>
      <div slot={MDSDialogSlotName.Header}>
        {/* This just pushes the close button to the right */}
        <div />
      </div>
      <StyledContent slot={MDSDialogSlotName.Content}>
        <img
          src={WelcomeToProImage}
          alt="abstract geometry containing things that looks like books, hands, and other shapes"
          width={366}
        />
        <MDSText variant={MDSTextVariant.HeaderL}>Welcome to Mem Pro</MDSText>

        <MDSText variant={MDSTextVariant.ParagraphSm}>
          You&apos;ve unlocked unlimited access to
          <br />
          your AI thought partner.
        </MDSText>
      </StyledContent>

      <StyledFooter slot={MDSDialogSlotName.Footer}>
        <MDSButton onClick={onClose} variant={MDSButtonVariant.Contrast}>
          Got it, continue
        </MDSButton>
      </StyledFooter>
    </MDSModalDialog>
  );
};

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 366px;
  text-align: center;
  margin-top: -${({ theme }) => theme.spacing.xxl};
  gap: ${({ theme }) => theme.spacing.sm};
`;

const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.smd};
`;
